import { Multiselect } from 'multiselect-react-dropdown';

export default Multiselect;
